// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Fwmfz","danger":"Button_danger__lfrDp","ghost":"Button_ghost__dgmuk","primary":"Button_primary__BRzUJ"};